import React from 'react';
import UserProfileReportTable from '../../components/UserProfileReportTable';

const CustomersProfileReportTable = () => (
  <UserProfileReportTable
    endpoint="users/customers"
    title="Customer Profile Report"
    exportName="Customers"
    emptyMessage="No customers found"
  />
);

export default CustomersProfileReportTable;
